(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arpa-header"]) return;
  try {
    
function initArpaNavigation(){const header=document.querySelector('.store-header');if(!header||header.dataset.ready)return;header.dataset.ready='true';const navigation = document.getElementById('shop-navigation');
const toggle = document.querySelector('.menu-toggle');
const mobile = window.matchMedia('(max-width: 800px)');
const groups = [...navigation.querySelectorAll('details')];
function closeGroups(except) { groups.forEach(group => { if (group !== except) group.open = false; }); }
function updateLayout() { navigation.hidden = mobile.matches; toggle.hidden = !mobile.matches; toggle.setAttribute('aria-expanded', 'false'); closeGroups(); }
toggle.addEventListener('click', () => { const open = toggle.getAttribute('aria-expanded') !== 'true'; toggle.setAttribute('aria-expanded', String(open)); navigation.hidden = !open; if (!open) closeGroups(); });
groups.forEach(group => group.addEventListener('toggle', () => { if (group.open) closeGroups(group); }));
document.addEventListener('click', event => { if (!navigation.contains(event.target)) closeGroups(); });
document.addEventListener('keydown', event => { if (event.key !== 'Escape') return; const open = groups.find(group => group.open); if (open) { open.open = false; open.querySelector('summary').focus(); } else if (mobile.matches && !navigation.hidden) { navigation.hidden = true; toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); } });
mobile.addEventListener('change', updateLayout);
updateLayout();
}
initArpaNavigation();document.addEventListener('shopify:section:load',initArpaNavigation);

  } catch(e) { console.error(e); }
})();
})();
